import { oliveSystem } from '@ds/icons'

const icons = {
  small: oliveSystem.icons,
  default: oliveSystem.icons,
}

export default icons
